import * as angular from 'angular';
import headerTemplate from './header.tpl.html';
import HeaderControllerName from './header.controller';

let requires = [HeaderControllerName];

/**
 * @module header
 * @file directive for the header template
 */
export default angular.module('aps.directive.header', requires)
  .directive('apsHeader', headerDef)
  .name;

/**
 * @method headerDef
 * @description directive definition
 * @returns {{
 *  restrict: string, scope: {}, templateUrl: string,
 *  replace: boolean, controller: string, controllerAs: string,
 *  bindToController: boolean
 * }}
 */
function headerDef() {
  return {
    restrict: 'E',
    scope: {},
    template: headerTemplate,
    replace: false,
    controller: 'HeaderCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/layout/header/header.directive.ts